import { CLIENT_CUSTOMER_ADDRESS_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { ICreatedCustomerAddressModel, ICustomerAddressModel } from "./customer-address.models";

export const getCustomerAddressesAPI = async () => {
  return await apiClient.getHttp<ICustomerAddressModel[]>(
    `${CLIENT_CUSTOMER_ADDRESS_API}`
  );
};

export const createdCustomerAddressesAPI = async (model: ICreatedCustomerAddressModel) => {
  return await apiClient.postHttp<number>(
    `${CLIENT_CUSTOMER_ADDRESS_API}`, model
  );
};

